import React from 'react';
import { InputGroup, MenuItem, Menu, Button, Popover } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import {
  ControlWrapper,
  SearchWrapper,
  FilterWrapper,
} from 'components/styled-components';
import isEqual from 'lodash/isEqual';
import shortid from 'shortid';
import debounce from 'lodash/debounce';
import constants from 'utils/constants';

const RenderedFilters = ({
  handleChangeFilter,
  active,
  filter,
  filterField,
  displayFilter,
}) => {
  return (
    <MenuItem
      onClick={() => handleChangeFilter(filter, filterField, displayFilter)}
      text={filter.label}
      key={shortid.generate()}
      active={isEqual(filter, active)}
    />
  );
};

const FilterMenu = props => {
  return (
    <Menu>
      <MenuItem text="Clear Filters" onClick={props.clearFilters} />
      <MenuItem text="Status" active={props.activeParent === 'Status'}>
        {props.statusFilters.map((status, i) => (
          <RenderedFilters
            filter={status}
            {...props}
            filterField="vendorStatus"
            displayFilter={`Status > ${status.value}`}
            key={shortid.generate()}
          />
        ))}
      </MenuItem>
      <MenuItem
        text="Certificate on File"
        active={props.activeParent === 'Certificate on File'}
      >
        {props.certificateFilters.map(value => (
          <RenderedFilters
            filter={value}
            {...props}
            filterField="certificate"
            displayFilter={value.value ? 'Has Certificate' : 'No Certificate'}
            key={shortid.generate()}
          />
        ))}
      </MenuItem>
      <MenuItem
        text="Third Party"
        active={props.activeParent === 'Third Party'}
      >
        {props.thirdPartyNameFilters.map(filter => (
          <RenderedFilters
            filter={filter}
            {...props}
            filterField="vendorName"
            displayFilter={`Third Party > ${filter.label}`}
            key={shortid.generate()}
          />
        ))}
      </MenuItem>
    </Menu>
  );
};

const Controls = ({
  handleSearch,
  filters,
  handleChangeFilter,
  selectedFilter,
  displayFilter,
  clearFilters,
  loaded,
  vendorStatus,
}) => {
  const throttledSearch = debounce(
    handleSearch,
    constants.SEARCH_TYPING_DELAY_MILLISECONDS
  );

  const handleQueryChange = e => {
    throttledSearch(e.target.value);
  };
  const thirdPartyNameFilters = [];
  const statusFilters = [];
  const certificateFilters = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  if (loaded) {
    filters.forEach(filter => {
      thirdPartyNameFilters.push({
        label: filter.vendorName,
        value: filter.vendorName,
      });
    });

    vendorStatus.forEach(filter => {
      statusFilters.push({
        label: filter.statusName,
        value: filter.statusName.toUpperCase(),
      });
    });
  }

  return (
    <React.Fragment>
      <SearchWrapper padding="1rem 2rem">
        <ControlWrapper>
          <InputGroup
            leftIcon={IconNames.SEARCH}
            placeholder={`Search Third Parties`}
            className="medium-text-group light-blue"
            onChange={handleQueryChange}
          />
          <div style={{ marginRight: '1rem' }} />
          <Popover
            content={
              <FilterMenu
                handleChangeFilter={handleChangeFilter}
                active={selectedFilter}
                activeParent={displayFilter}
                thirdPartyNameFilters={thirdPartyNameFilters}
                statusFilters={statusFilters}
                certificateFilters={certificateFilters}
                clearFilters={clearFilters}
              />
            }
            autoFocus={false}
          >
            <FilterWrapper>
              <Button
                icon={IconNames.FILTER_LIST}
                rightIcon="caret-down"
                text={displayFilter ? displayFilter : 'Filter'}
                className={`${
                  displayFilter === '' ? 'light-blue' : 'filter-selected'
                }`}
                fill={true}
                alignText="left"
              />
            </FilterWrapper>
          </Popover>
        </ControlWrapper>
      </SearchWrapper>
    </React.Fragment>
  );
};

export default Controls;
